import React, { ComponentProps } from "react";
import ButtonBase from "./Base";
import ButtonBluer from "./Bluer";

export type IButtonData = { content?: string; linkTo?: string, icon?: React.ReactNode };

const isButtonData = (value: any): value is IButtonData =>
  typeof value === "object" && value !== null;

const getButtonFromDataOrNode = (
  data: IButtonData | React.ReactNode,
  props: ComponentProps<typeof ButtonBluer> = {}
) =>
  isButtonData(data) ? (
    <ButtonBluer {...props} linkTo={data.linkTo}>
      {data.content}
      {data.icon ? <span style={{ marginLeft: '8px' }}>{data.icon}</span> : null}
    </ButtonBluer>
  ) : (
    data
  );

const Button = Object.assign(ButtonBase, {
  Bluer: ButtonBluer,
  getButtonFromDataOrNode,
});

export default Button;
